"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    fusionToNormalized: function() {
        return fusionToNormalized;
    },
    normalizedToFusion: function() {
        return normalizedToFusion;
    }
});
function fusionToNormalized(n) {
    return Math.round(100 * (n / 255));
}
function normalizedToFusion(n) {
    return Math.round(255 * (n / 100));
}
